// Loader.jsx
import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader-spinner">
        <div className="spinner-circle"></div>
      </div>
    </div>
  );
};

export default Loader;